export enum HeatDistributionSystem {
  FLOOR_HEATING = 'floor_heating'
}
